import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

function AdminDashboard() {
  const [dishes, setDishes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDishes();
  }, []);

  const fetchDishes = async () => {
    try {
      const res = await axios.get("https://api.kafkaorostkaffee.com/dishes");
      setDishes(res.data);
    } catch (err) {
      console.error("Error fetching dishes:", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this dish?")) return;
    try {
      await axios.delete(`https://api.kafkaorostkaffee.com/dishes/${id}`);
      fetchDishes(); // Refresh the list
    } catch (err) {
      console.error("Error deleting dish:", err);
    }
  };

 

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h2>Dishes List</h2>
        <button onClick={() => navigate("/admin")}>+ Add Dish</button>
      </div>

      <table className="dishes-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Price</th>
            <th>Category</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {dishes.map((dish) => (
            <tr key={dish.id}>
              <td>{dish.id}</td>
              <td>{dish.title}</td>
              <td>{dish.price}</td>
              <td>{dish.category}</td>
              <td>{dish.description}</td>
              <td>
                        
            <button className="edit-btn" onClick={() => navigate(`/edit-dish/${dish.id}`)}>Edit</button>
            <button className="delete-btn" onClick={() => handleDelete(dish.id)}>Delete</button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#06402B",
          color: "white",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer"
        }}
        onClick={() => navigate("/")}
      >
        Back to Menu
      </button>
    </div>
  );
}

export default AdminDashboard;
